import React, { useEffect, useState, useRef } from 'react';
import { Bell, Plus, ArrowRight, MoveUpRight, ChevronUp, ChevronDown, Eye, EyeOff, Download, X, FileDown } from 'lucide-react';
import logo1 from '../../assets/videos.png';
import logo4 from '../../assets/agent.png';
import logo2 from '../../assets/activat.png';
import logo3 from '../../assets/stock.png';
import car from '../../assets/images/container.png';
import fastag from '../../assets/fastaglogo.png';
import { Button } from '../../Common/Button';
import FitmentCertificateModal from '../../components/common/FitmentCertificateModal';
import hiicon from '../../assets/images/hi.png';
import FastagPurchase from '../../Commponent/FastagPurchase';
import AgentFastagRequest from '../../Commponent/AgentFastagRequest';
import { getRole } from '../../Utils/auth';
import CommonTable from '../../Common/CommonTable';
import AddAgent from '../../Commponent/AddAgent';
import AddBulkAgents from '../../Commponent/AddBulkAgents';
import { getVehicleClassData } from '../../Utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { ErrorToast, SuccessToast } from '../../Utils/toast';
import moment from 'moment';
import CommonModal from '../../Commponent/CommonModal';
import { API } from '../../Common/Api';
import { useNavigate } from 'react-router-dom';

// Per-metric accent styling for the dashboard stat cards.
// Full literal class names are kept here so Tailwind's content scanner keeps them.
const STAT_ACCENTS = {
  "Total Purchased FASTags": { iconBg: "bg-indigo-50", bar: "from-indigo-500 to-indigo-300", glow: "bg-indigo-500/10", value: "text-indigo-600", hoverRing: "hover:ring-indigo-100" },
  "Activated FASTags": { iconBg: "bg-emerald-50", bar: "from-emerald-500 to-emerald-300", glow: "bg-emerald-500/10", value: "text-emerald-600", hoverRing: "hover:ring-emerald-100" },
  "Available Stock": { iconBg: "bg-rose-50", bar: "from-[#EE3B31] to-rose-300", glow: "bg-[#EE3B31]/10", value: "text-[#EE3B31]", hoverRing: "hover:ring-rose-100" },
  "Assigned to Dealer": { iconBg: "bg-violet-50", bar: "from-violet-500 to-violet-300", glow: "bg-violet-500/10", value: "text-violet-600", hoverRing: "hover:ring-violet-100" },
  "Assigned to Agents": { iconBg: "bg-amber-50", bar: "from-amber-500 to-amber-300", glow: "bg-amber-500/10", value: "text-amber-600", hoverRing: "hover:ring-amber-100" },
};
const DEFAULT_ACCENT = { iconBg: "bg-gray-50", bar: "from-gray-400 to-gray-200", glow: "bg-gray-500/10", value: "text-gray-900", hoverRing: "hover:ring-gray-100" };

//distributor dashboard
const Dashboard = () => {
  const dispatch = useDispatch();
  const role = getRole();
  const isDealer = role === 'dealer';
  const GetDistributorRequest = useSelector((state) => state.GetDistributorRequest.GetDistributorRequestData);
  const CreateAgentBulk = useSelector((state) => state.CreateAgentBulk.CreateAgentBulkData);
  const GetDistributorSummary = useSelector((state) => state.GetDistributorSummary.GetDistributorSummaryData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [show, setShow] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  const [addAgentsOpen, setAddAgentsOpen] = useState(false);
  const [addBulkAgentsOpen, setAddBulkAgentsOpen] = useState(false);
  const [addDealerOpen, setAddDealerOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [checkGetDistributorRequest, setCheckGetDistributorRequest] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [approvalNote, setApprovalNote] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: "", direction: null });
  const [file, setFile] = useState("");
  const [userData, setUserData] = useState(null);
  const [checkCreateAgentBulk, setCheckCreateAgentBulk] = useState(false);
  const [checkGetDistributorSummary, setCheckGetDistributorSummary] = useState(false);

  useEffect(() => {
    getData()
    getDataInit()
    getDistributorSummaryData()
  }, [refreshCount]);


  const getDataInit = async () => {
    const data = localStorage.getItem('UserDetail');


    setUserData(JSON.parse(data));
  }


  const getData = async () => {
    let params = {
      page: 1,
      limit: 10,
    }
    // A dealer's "My Fastag Request" list comes from their own agent-style
    // requests raised up to their distributor (scope=own), not the distributor
    // purchase-request collection.
    if (isDealer) {
      try {
        const response = await API.GetAllFastagAgentRequest({ ...params, scope: 'own' });
        setTableData(response?.status === 200 && response?.success ? (response.data || []) : []);
      } catch (e) {
        setTableData([]);
      }
      return;
    }
    setCheckGetDistributorRequest(true)
    dispatch(ACTIONS.GetDistributorRequestAction(params));
  }

  const getDistributorSummaryData = () => {
    setCheckGetDistributorSummary(true);
    dispatch(ACTIONS.GetDistributorSummaryAction());
  }

  const refreshAll = () => {
    getData();
    getDataInit();
    getDistributorSummaryData();
  }

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction:
            prev.direction === "asc"
              ? "desc"
              : prev.direction === "desc"
                ? null
                : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };
  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc")
        return (
          <ChevronUp className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
      if (sortConfig.direction === "desc")
        return (
          <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
    }
    return (
      <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#E0E0E0]" />
    );
  };



  useEffect(() => {
    if (checkGetDistributorRequest) {
      if (GetDistributorRequest?.status == 200 && GetDistributorRequest?.success) {
        setTableData(GetDistributorRequest?.data?.data || []);
      } else if (GetDistributorRequest?.message) {
        // Only show error toast if message is a non-empty string
        const msg = typeof GetDistributorRequest.message === 'string'
          ? GetDistributorRequest.message
          : 'Failed to fetch distributor requests';
        ErrorToast(msg);
      }
      setCheckGetDistributorRequest(false);
    }
  }, [GetDistributorRequest])

  // Handle CreateAgentBulk response
  useEffect(() => {
    if (CreateAgentBulk && checkCreateAgentBulk) {
      // Check if the API call was successful (status 200)
      if (CreateAgentBulk?.status === 200) {
        const { message, inserted, failed, details } = CreateAgentBulk;

        // Create detailed success message based on status only
        let detailedMessage = `${message || 'Bulk agent upload completed'}. Successfully added: ${inserted || 0} agents`;

        // Add failure information if any
        if (failed && failed > 0) {
          detailedMessage += `, Failed: ${failed}`;

          // Show detailed failure information only if there are actual failures
          if (details?.failed && Array.isArray(details.failed) && details.failed.length > 0) {
            const failureReasons = details.failed.map(failure => {
              // Handle your API structure: failure.data contains the original row data
              const username = failure.data?.username || 'Unknown';
              const reason = failure.reason || 'Unknown error';
              const rowNumber = failure.row || 'Unknown row';
              return `Row ${rowNumber} (${username}): ${reason}`;
            }).join('; ');

            // Show warning toast for failures
            setTimeout(() => {
              ErrorToast(`Failed entries: ${failureReasons}`);
            }, 1000);
          }
        }

        // Show success toast for status 200
        SuccessToast(detailedMessage);
        // NOTE: Do NOT call refreshAll() here — the saga already dispatches REFRESH_DATA
        // which triggers the refreshCount useEffect to reload data. Calling refreshAll()
        // here would cause double API calls and can trigger infinite re-render loops.
        setAddBulkAgentsOpen(false); // Close modal
        setFile(''); // Reset file
      } else {
        // Handle error cases (400, 500, etc.)
        const errorMessage = typeof CreateAgentBulk?.message === 'string'
          ? CreateAgentBulk.message
          : typeof CreateAgentBulk?.error === 'string'
            ? CreateAgentBulk.error
            : 'Failed to create bulk agents';
        ErrorToast(errorMessage);
        // Keep modal open for user to fix issues
      }

      setCheckCreateAgentBulk(false);
    }
  }, [CreateAgentBulk, checkCreateAgentBulk])

  // Handle GetDistributorSummary response
  useEffect(() => {
    if (checkGetDistributorSummary && GetDistributorSummary) {
      if (GetDistributorSummary?.status === 200 && GetDistributorSummary?.success) {
        console.log('📊 Dashboard - Distributor Summary API Response:', GetDistributorSummary?.data);
      } else if (GetDistributorSummary?.message) {
        console.error('❌ Dashboard - Failed to fetch distributor summary:', GetDistributorSummary?.message);
      }
      setCheckGetDistributorSummary(false);
    }
  }, [GetDistributorSummary, checkGetDistributorSummary])

  const [assigningAgent, setAssigningAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    if (window.innerWidth >= 0) {
      setModalOpen(!isVisible);
    }

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };

  const StatusBadge = ({ status }) => {
    const base = "px-2 py-[2px] rounded-full text-xs font-medium flex items-center gap-1 justify-self-start";
    if (status === "Assigned")
      return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Assigned</span>;
    if (status === "Unassigned")
      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Unassigned</span>;
    if(status === "Rejected")
      return <span className={`${base} bg-red-100 text-red-900`}><span className="h-2 w-2 bg-red-500 rounded-full" />Rejected</span>;
    return null;
  };

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);

  const tableColumns = [
    {
      label: "Requested By",
      key: "name",
      render: (row) => (
        <div>
          <div className="font-medium text-[#1F1715]">{row.user?.username}</div>
          <div className="text-xs text-[#000000]">{row.user?.email}</div>
        </div>
      ),
    },
    { label: "Mobile Number", render: (row) => row.user?.mobileNo },
    {
      label: (
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => handleSort("vehicleClass")}
        >
          Vehicle Class {getSortIcon("vehicleClass")}
        </div>
      ),
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px]"
            />
            <p>{vehicleClassData.value}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    { label: "Requested Date", render: (row) => moment(row.createdAt).format("DD MMMM, YYYY hh:mm A"), },
    { label: "Recieved Date", render: (row) => moment(row.updatedAt).format("DD MMMM, YYYY hh:mm A"), },
    { label: "Quantity", key: "quantity" },
    { label: "Status", key: "status", render: (row) => <StatusBadge status={row.status} /> },
    {
      label: "Assign  Inventory",
      tdClassName: 'flex justify-end',
      render: (row) => row.user?.username
    }

  ];

  // Create statsData with actual API data
  const statsData = [
    {
      id: 1,
      title: "Total Purchased FASTags",
      value: GetDistributorSummary?.data?.totalFastag?.count || "0",
      percentage: (GetDistributorSummary?.data?.totalFastag?.count > 0) ? Math.min(100, GetDistributorSummary?.data?.totalFastag?.percentage || 0) : "0%",
      iconColor: logo1
    },
    {
      id: 2,
      title: "Activated FASTags",
      value: GetDistributorSummary?.data?.userAssigned?.count || "0",
      percentage: (GetDistributorSummary?.data?.userAssigned?.count > 0) ? Math.min(100, GetDistributorSummary?.data?.userAssigned?.percentage || 0) : "0%",
      iconColor: logo2
    },
    {
      id: 3,
      title: "Available Stock",
      value: GetDistributorSummary?.data?.availableStock?.count || "0",
      percentage: (GetDistributorSummary?.data?.availableStock?.count > 0) ? Math.min(100, GetDistributorSummary?.data?.availableStock?.percentage || 0) : "0%",
      iconColor: logo3
    },
    {
      id: 5,
      title: "Assigned to Dealer",
      value: GetDistributorSummary?.data?.dealerAssigned?.count || "0",
      percentage: (GetDistributorSummary?.data?.dealerAssigned?.count > 0) ? Math.min(100, GetDistributorSummary?.data?.dealerAssigned?.percentage || 0) : "0%",
      iconColor: logo4
    },
    {
      id: 4,
      title: "Assigned to Agents",
      value: GetDistributorSummary?.data?.agentAssigned?.count || "0",
      percentage: (GetDistributorSummary?.data?.agentAssigned?.count > 0) ? Math.min(100, GetDistributorSummary?.data?.agentAssigned?.percentage || 0) : "0%",
      iconColor: logo4
    }
  ].filter((stat) => !(isDealer && stat.title === "Assigned to Dealer"));

  const isInventoryEmpty = (GetDistributorSummary?.data?.availableStock?.count || 0) === 0;


  // Profile data
  const profileData = {
    name: "Your Profile",
    status: userData?.username || userData?.role,
    phone: userData?.mobileNo ? `+91 ${userData.mobileNo}` : '',
    message: "Continue your journey and achieve your target",
  };


  const handleApprove = async () => {
    const data = {
      FasTagIds: [assigningAgent._id],
      remark: approvalNote
    }

    const response = await API.ApproveFastag(JSON.stringify(data));

    if (response.status === 200 && response.success) {
      SuccessToast(response.message);
      dispatch({ type: "REFRESH_DATA" });
      setIsModalOpen(false);
    } else {
      ErrorToast(response.message);
    }

  }

  // Secure file download handler
  const handleSecureDownload = async (fileUrl) => {
    if (!fileUrl) {
      ErrorToast('No file URL available');
      return;
    }

    try {
      const requestBody = JSON.stringify({
        InventoryExcleURL: fileUrl
      });
      const blob = await API.DownloadFile(requestBody);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      const urlParts = fileUrl.split('/');
      const filename = urlParts[urlParts.length - 1] || 'screenshot.jpg';
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      SuccessToast('File downloaded successfully');
    } catch (error) {
      console.error('Download failed:', error);
      ErrorToast('Failed to download file. Please try again.');
    }
  }

  // Bulk agent handlers
  const handleSubmit = () => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);

      console.log('🚀 Dashboard - Submitting bulk agents:', file.name);

      // Dispatch Redux action for bulk agent creation
      setCheckCreateAgentBulk(true);
      dispatch(ACTIONS.CreateAgentBulkAction(formData));
    } else {
      ErrorToast('Please select a file to upload.');
    }
  }

  const SubmitButton = () => {
    return (
      <button
        onClick={handleSubmit}
        className="mt-2 bg-[#EE3B31] text-white rounded-full py-2 w-full"
      >
        Submit
      </button>
    )
  }

  const handleUpload = (fileRaw) => {
    setFile(fileRaw);
  }

  const navigate = useNavigate();
  const [fitmentOpen, setFitmentOpen] = useState(false);
  const onboardMenuRef = useRef(null);

  // Close onboard menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (onboardMenuRef.current && !onboardMenuRef.current.contains(e.target)) {
        setAddMenuOpen(false);
      }
    };
    if (addMenuOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [addMenuOpen]);

  return (
    <>
      {fitmentOpen && <FitmentCertificateModal onClose={() => setFitmentOpen(false)} />}
      <div className="">
        <div className="mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 xl:gap-6 lg:gap-2 gap-6">
            <div className="lg:col-span-3">
              <div className="flex flex-col mb-[16px]">
                <div className="flex justify-end">
                  <div className="flex items-center gap-3 hidden md:flex">
                    <Button
                      label="Download Fitment Certificate"
                      icon={<FileDown className="w-4 h-4" />}
                      iconPosition="right"
                      roundedButton={true}
                      onClick={() => setFitmentOpen(true)}
                      style={{ backgroundColor: "#EE3B31", fontWeight: "700" }}
                    />

                    <div className="relative inline-block" ref={onboardMenuRef}>
                      <Button
                        label="Onboard Team"
                        icon={<Plus className="w-4 h-4" />}
                        iconPosition="right"
                        roundedButton={true}
                        onClick={(e) => {
                          e.stopPropagation();
                          setAddMenuOpen((prev) => !prev);
                        }}
                        style={{ backgroundColor: "#EE3B31", fontWeight: "700" }}
                      />

                      {addMenuOpen && (
                        <div
                          className="absolute right-0 mt-2 bg-white border rounded shadow z-[500] min-w-max"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={() => {
                              setAddMenuOpen(false);
                              setAddAgentsOpen(true);
                            }}
                            className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap cursor-pointer"
                          >
                            Add Agent +
                          </button>
                          <button
                            onClick={() => {
                              setAddMenuOpen(false);
                              setAddBulkAgentsOpen(true);
                            }}
                            className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap cursor-pointer"
                          >
                            Add Bulk Agent
                          </button>
                          {!isDealer && (
                            <button
                              onClick={() => {
                                setAddMenuOpen(false);
                                setAddDealerOpen(true);
                              }}
                              className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap cursor-pointer"
                            >
                              Add Dealer +
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative overflow-hidden rounded-2xl text-white my-[16px] min-h-[172px] shadow-lg">
                <div
                  className="absolute inset-0 bg-cover bg-no-repeat bg-center scale-105"
                  style={{ backgroundImage: `url(${car})` }}
                ></div>
                {/* Brand-tinted gradient keeps the copy readable over the photo */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-transparent"></div>
                <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-[#EE3B31]/30 blur-3xl"></div>
                <div className="relative z-10 h-full flex flex-col justify-center px-[28px] py-[26px]">
                  <h1 className="text-2xl md:text-3xl font-bold mb-1 tracking-tight">Track FASTag &amp; Manage Agents</h1>
                  <p className="text-sm md:text-base text-white/80 mb-4">Grow with Omnicard.</p>
                  <button className="w-fit bg-white text-gray-900 px-6 py-2 rounded-full text-xs font-bold hover:bg-gray-100 transition-colors shadow">
                    Allocate FASTag
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-[14px]">
                {statsData.map((stat, index) => {
                  const accent = STAT_ACCENTS[stat.title] || DEFAULT_ACCENT;
                  const isWide = index === statsData.length - 1 && statsData.length % 2 === 1;
                  return (
                    <div
                      key={stat.id}
                      className={`group relative overflow-hidden bg-white rounded-2xl border border-gray-100 shadow-sm ring-1 ring-transparent ${accent.hoverRing} hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 ${isWide ? "md:col-span-2" : ""}`}
                      style={{ padding: "20px" }}
                    >
                      <div className={`absolute left-0 top-0 h-full w-1 bg-gradient-to-b ${accent.bar}`}></div>
                      <div className={`absolute -right-6 -top-6 w-24 h-24 rounded-full ${accent.glow} blur-2xl opacity-0 group-hover:opacity-100 transition-opacity`}></div>
                      <div className="relative flex items-center gap-4">
                        <div className={`shrink-0 rounded-2xl ${accent.iconBg} flex items-center justify-center`} style={{ width: "58px", height: "58px" }}>
                          <img
                            src={stat.iconColor}
                            alt=""
                            className={index === 1 ? "w-[26px] h-[30px]" : "w-[30px] h-[30px]"}
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-gray-500 text-sm font-medium mb-1 truncate">{stat.title}</p>
                          <p className={`text-3xl font-extrabold tracking-tight ${accent.value}`}>{stat.value}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Profile Section */}
            <div className="w-full md:block hidden">
              <div className="relative overflow-hidden bg-white rounded-2xl shadow-sm border border-gray-100 min-h-[444px]">
                {/* gradient header banner */}
                <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-br from-[#EE3B31] to-rose-400"></div>
                <div className="relative flex flex-col min-h-[444px] p-[25px]">
                  <div className="flex items-center justify-between mb-8">
                    <h3 className="font-semibold text-white text-lg md:text-xl">{profileData.name}</h3>
                  </div>

                  <div className="flex justify-center mb-4">
                    <div className="p-1.5 rounded-full bg-white shadow-lg ring-4 ring-white">
                      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-rose-50 to-indigo-50 flex items-center justify-center">
                        <img
                          src={hiicon}
                          className="w-14 h-14 object-contain"
                          onError={(e) => (e.target.style.display = 'none')}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-center mb-1">
                    <h4 className="text-xl font-bold text-gray-900 mb-1">{profileData.status}</h4>
                    <p className="text-gray-500 text-sm">{profileData.phone}</p>
                  </div>

                  <div className="text-center mt-2">
                    <p className="text-gray-500 text-sm leading-relaxed whitespace-pre-line px-2">
                      {profileData.message}
                    </p>
                  </div>

                  <button
                    className="mt-6 w-full bg-emerald-500 hover:bg-emerald-600 text-white py-3 rounded-full font-semibold flex items-center justify-center gap-2 transition-colors shadow-sm"
                    onClick={() => setShow(true)}
                  >
                    <span className="text-sm font-bold">Purchase FASTag</span>
                    <ArrowRight className="!w-[16px] !h-[16px]" />
                  </button>

                  <div className="mt-auto pt-6 border-t border-gray-100 text-center">
                    <img
                      src={fastag}
                      className="h-8 object-contain mx-auto"
                      onError={(e) => (e.target.style.display = 'none')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl p-6">
              <div className="absolute top-4 right-4 gap-3 flex-row flex">
                <button
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedIndex !== null) {
                      toggleVisibility(selectedIndex, selectedClass);
                    }
                  }}
                  className="text-gray-600 hover:text-red-500"
                >
                  <X size={20} />
                </button>
              </div>
              <h2 className="text-xl font-semibold mb-[4px] text-center">
                {vehicleData?.value}
              </h2>
              <p className="mb-[30px] text-sm text-center">
                {vehicleData?.description}
              </p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>
                  
                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>
                  
                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <CommonModal
          isOpen={isModalOpen}
          closeOnOutsideClick={false}
          onClose={() => setIsModalOpen(false)}
          title={`FASTag Request: ${assigningAgent?.user?.username}`}
          size="max-w-xl"
          footer={
            <div className="flex justify-end gap-4">
              <Button
                label="Cancel"
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-200 text-gray-800 hover:bg-gray-300 px-4 py-2 rounded-md"
              />
              <Button
                label="Approve"
                onClick={handleApprove}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md"
              />
            </div>
          }
        >
          <div className="grid grid-cols-2 gap-3 mb-3">
            <label className="block text-sm font-medium text-gray-700 ">Assigning Agent : {assigningAgent?.user?.username}</label>
            <label className="block text-sm font-medium text-gray-700 ">Mobile : {assigningAgent?.user?.mobileNo}</label>
            <label className="block text-sm font-medium text-gray-700 ">Vehicle Class : {assigningAgent?.vehicleClass}</label>
            <label className="block text-sm font-medium text-gray-700 flex items-center gap-2">Payment Proof : 
              {assigningAgent?.utrnumber ? assigningAgent.utrnumber : 
               assigningAgent?.fileUrl ? 
                 <button
                   onClick={(e) => { e.preventDefault(); handleSecureDownload(assigningAgent.fileUrl); }}
                   className="text-blue-500 hover:text-blue-700 hover:underline cursor-pointer bg-transparent border-none p-0"
                 >
                   View Screenshot
                 </button>
               : ' -'}
            </label>
            <label className="block text-sm font-medium text-gray-700 ">Quantity : {assigningAgent?.quantity}</label>
            <label className="block text-sm font-medium text-gray-700 ">Total Amount : {assigningAgent?.price}</label>
            <label className="block text-sm font-medium text-gray-700 ">Requested Date : {moment(assigningAgent?.createdAt).format('DD MMMM, YYYY, hh:mm A')}</label>

          </div>

          <label className="block text-sm font-medium text-gray-700 mb-3">Approval Note</label>
          <input
            type="text"
            placeholder="Enter remarks (optional)"
            value={approvalNote}
            onChange={(e) => setApprovalNote(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
          />
        </CommonModal>

      </div >

      {/* Table Header */}
      < div className="min-w-auto bg-[#FFFFFF] rounded-t-2xl shadow-sm border border-gray-100 border-b-0 mt-[16px] md:mt-10" >
        <div className="flex justify-between items-center px-[24px] py-[18px]">
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-6 rounded-full bg-[#EE3B31]"></span>
            <h2 className="text-lg md:text-xl font-semibold text-gray-900">My Fastag Request</h2>
          </div>
          <button
            onClick={() => !isInventoryEmpty && navigate('/agents')}
            disabled={isInventoryEmpty}
            title="View all requests"
            className={`group rounded-full w-9 h-9 flex justify-center items-center transition-colors
              ${isInventoryEmpty
                ? "cursor-not-allowed bg-gray-100 opacity-50"
                : "cursor-pointer bg-[#F5F5F5] hover:bg-[#EE3B31]"}`}
          >
            <MoveUpRight className={`w-[18px] h-[18px] transition-colors ${isInventoryEmpty ? "text-gray-400" : "text-[#EE3B31] group-hover:text-white"}`} />
          </button>
        </div>
      </div >

      {/* Table */}
      < CommonTable columns={tableColumns} data={tableData} emptyMessage="No Inventory Found" />

      {show && (
        isDealer
          ? <AgentFastagRequest onClose={() => { setShow(false); refreshAll(); }} />
          : <FastagPurchase onClose={() => { setShow(false); refreshAll(); }} />
      )}
      {addAgentsOpen && <AddAgent onClose={() => { setAddAgentsOpen(false); refreshAll(); }} modalOpen={addAgentsOpen} setModalOpen={setAddAgentsOpen} />}
      {addDealerOpen && <AddAgent api="CreateDealer" title="Add Dealer" onClose={() => { setAddDealerOpen(false); refreshAll(); }} modalOpen={addDealerOpen} setModalOpen={setAddDealerOpen} />}
      {addBulkAgentsOpen && (
        <AddBulkAgents
          onClose={() => { setAddBulkAgentsOpen(false); refreshAll(); }}
          sidebarTitle="Add Bulk Agent +"
          sampleFileName="upload_agent_sample"
          csvFileName="upload agent sample.csv"
          xlsxFileName="upload agent sample.xlsx"
          sampleFileUrls={{
            excel: "/upload agent sample.xlsx",
            csv: "/upload agent sample.csv"
          }}
          onUpload={handleUpload}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default Dashboard;
